// removed by extract-text-webpack-plugin
module.exports = {"stepLabel":"_3ausb5d2kpt2ukdctnxf447kb6yzvcqy3wwq2p4336wkqguj6z86sqwvek84spgxpnwbx4tmr5wy15hdgeegt4re8dcjm3csm2d2x6m-patientInfoFormCarousel-module-stepLabel","skipForm":"_3dwjkkychqt828pfs8c8ay6w5dqztxxjx9avkseqdng3q3cnfa5w2dvwbmcmxkdcr3p4ujt8ph9rqdrkutz245hbn1ut9u9yphu861t-patientInfoFormCarousel-module-skipForm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/styles/patientInfoFormCarousel.module.scss
// module id = 501
// module chunks = 0